import React, { useEffect, useState } from 'react'
import { Modal, Tooltip, Icon } from 'antd'
import { Button, ColumnProps, notification, Table } from '@digital/ui'
import { deleteAnexos, getArquivosDocumento } from '@app/api/sas/sasDocumentoOrdemCompra'
import { Visibility } from '@app/components'
import { useRecoilState } from 'recoil'
import { reloadAnexosState } from '../atoms'

interface Props {
    sasDocumentoOrdemComraId: string
}

const ModalDeleteAnexo = (props: Props) => {
    const { sasDocumentoOrdemComraId } = props;
    const [exibirModal, setExibirModal] = useState(false)
    const [arquivos, setArquivos] = useState([])
    const [checks, setChecks] = useState([])
    const [reloadFiles, setReloadFiles] = useRecoilState(reloadAnexosState);


    useEffect(() => {
        if (exibirModal === true) {
            getArquivosDocumento(sasDocumentoOrdemComraId).then(data => {
                if (data) setArquivos(data)
            })
        }
    }, [exibirModal, reloadFiles])

    const onChangeSelections = (selectedRowKeys) => {
        setChecks([...selectedRowKeys])
    }

    const onEnviar = () => {
        if (checks.length > 0 && checks.length === arquivos.length) {
            Modal.confirm({
                title: 'Deletar Itens',
                icon: <Icon type="info-circle" />,
                content: 'Deseja excluir todos esses registros, incluindo todo seu histórico?',
                onOk() {
                    deleteAnexos(checks).then(data => {
                        if (data) {
                            notification.success('Item removido com sucesso.');
                            setReloadFiles(!reloadFiles)
                            setExibirModal(false)
                            setChecks([])
                        }
                    })
                },
                onCancel() { },
            });
        } else if (checks.length > 0 && checks.length < arquivos.length) {
            Modal.confirm({
                title: 'Deletar Itens',
                icon: <Icon type="info-circle" />,
                content: 'Deseja excluir esse(s) arquivos?',
                onOk() {
                    deleteAnexos(checks).then(data => {
                        if (data) {
                            notification.success('Item removido com sucesso.');
                            setReloadFiles(!reloadFiles)
                            setChecks([])
                        }
                    })
                },
                onCancel() { },
            });
        }
    }

    const columns = () => {
        let columns: ColumnProps<any>[] = [];

        columns.push({
            title: 'Arquivo',
            dataIndex: 'nome',
            // width: '40%'
        })

        columns.push({
            title: 'Status',
            className: "td-centralizado",
            dataIndex: 'vigente',
            width: '15%'
        })

        columns.push({
            title: 'Versão',
            className: "td-centralizado",
            dataIndex: 'versao',
            width: '10%'
        })

        return columns;
    }

    return (
        <>
            <Tooltip title="Deletar Anexos">
                <Button
                    onClick={() => {
                        setExibirModal(true)
                    }}
                    icon="commons-trash"
                />
            </Tooltip>
            <Visibility
                visible={exibirModal}
            >
                <Modal
                    title="Anexos"
                    width="680px"
                    visible={exibirModal}
                    onCancel={() => setExibirModal(false)}
                    footer={
                        <Button title='Deletar' onClick={() => onEnviar()} />
                    }
                >
                    <Table
                        dataSource={arquivos}
                        columns={columns()}
                        rowKey="id"
                        pagination={false}
                        rowSelection={{
                            onChange: onChangeSelections
                        }}
                    />
                </Modal>
            </Visibility>
        </>
    )
}

export default ModalDeleteAnexo